import { useState } from "react";
import { Menu, X, ArrowRight } from "lucide-react";

const LINKS = [
  { href: "#why", label: "Why It Matters" },
  { href: "#services", label: "Services" },
  { href: "#who", label: "Who We Serve" },
  { href: "#process", label: "Process" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-nav"
      className="xw-nav sticky top-0 z-50 border-b border-[var(--xw-line)]"
    >
      <div className="xw-container flex items-center justify-between h-[60px] md:h-[68px]">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span
            className="inline-flex items-center justify-center w-7 h-7 rounded-[2px]"
            style={{ background: "var(--xw-orange)", color: "#fff" }}
          >
            <span className="font-display font-black text-lg leading-none">X</span>
          </span>
          <span className="font-display font-black uppercase tracking-tight text-[15px] md:text-[17px]">
            Xterior<span className="text-[var(--xw-orange)]">/</span>Works
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="xw-link-underline font-mono-xw text-[12px] uppercase tracking-[0.18em]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-contact"
          className="hidden md:inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-semibold border border-[var(--xw-ink)] bg-[var(--xw-ink)] text-white hover:bg-[var(--xw-orange)] hover:border-[var(--xw-orange)] transition-colors rounded-[2px]"
        >
          Request Consultation
          <ArrowRight size={14} />
        </a>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle navigation"
          className="md:hidden p-2 border border-[var(--xw-ink)] rounded-[2px]"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-[var(--xw-line)] bg-[var(--xw-bg)]"
        >
          <div className="xw-container py-4 flex flex-col gap-3">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                onClick={() => setOpen(false)}
                className="font-mono-xw text-[12px] uppercase tracking-[0.18em] py-2"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="nav-mobile-cta-contact"
              onClick={() => setOpen(false)}
              className="btn-solid justify-center mt-2"
            >
              Request Consultation <ArrowRight size={14} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
